var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-menu',_vm._b({attrs:{"close-on-content-click":false},scopedSlots:_vm._u([{key:"activator",fn:function(ref){
var on = ref.on;
var attrs = ref.attrs;
return [_vm._t("activator",null,null,{ on: on, attrs: attrs })]}}],null,true)},'v-menu',{
    top: _vm.top,
    bottom: _vm.bottom,
    right: _vm.right,
    left: _vm.left,
    offsetX: _vm.offsetX,
    offsetY: _vm.offsetY,
  },false),[_c('v-card',{attrs:{"width":"300px"}},[_c('user-menu'),_c('v-divider'),_c('app-menu')],1),_c('v-btn',{attrs:{"block":"","tile":"","color":"primary"},domProps:{"textContent":_vm._s('Sign out')},on:{"click":_vm.logout}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }